import React from 'react';

import { getHumanReadableCount } from '@lyearn/core/utils/number/getHumanReadableCount';
import { useTranslation } from '@lyearn/i18n';
import { Sync } from '@lyearn/icons';
import { Box, Stack, Tooltip, Typography } from '@lyearn/ui';
import { GroupTypeEnum } from '@/types/schema';

import { getGroupImage } from '../../../utils';
import { CollectionItemProps } from './types';

const CollectionItem: React.FC<CollectionItemProps> = (props) => {
  const { group } = props;
  const { t } = useTranslation('Group');
  const Image = getGroupImage({ group, type: GroupTypeEnum.ContentCollection, t });

  return (
    <Stack>
      {Image}
      <Stack className="ms-16" direction="col">
        <Stack alignItems="center" className="space-s-8">
          <Typography color="text-text-primary" title={group.name} variant="label-01">
            {group.name}
          </Typography>
          {group.isAutoSyncGroup ? (
            <Tooltip placement="top" title={t('Group:Manager.AutoSyncWithCondition')!}>
              <Box role="tooltip" tabIndex={0}>
                <Sync className="h-16 w-16 fill-current text-icon-placeholder hover:text-icon-secondary" />
              </Box>
            </Tooltip>
          ) : null}
        </Stack>
        <Stack className="mt-2">
          {group.memberCount ? (
            <Typography color="text-text-secondary" variant="body-short-02">
              {t('Group:Manager.item', {
                count: group.memberCount,
                humanReadableCount: getHumanReadableCount(group.memberCount),
              })}
            </Typography>
          ) : null}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default CollectionItem;
